
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const CtaSection = () => {
  return (
    <section className="py-20 px-6 bg-gradient-to-br from-clustr-blue to-clustr-magenta text-white">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-6">
          Ready to capture your inspiration?
        </h2>
        <p className="text-xl mb-8 opacity-90">
          Join Clustr today and never lose track of inspiring content again.
        </p>
        <Button asChild size="lg" className="bg-white text-clustr-blue hover:bg-gray-100 px-8 py-6 text-lg">
          <Link to="/auth">
            Get started for free
          </Link>
        </Button>
        <p className="mt-4 text-sm opacity-75">
          No credit card required • Cancel anytime
        </p>
      </div>
    </section>
  );
};

export default CtaSection;
